/**
 * helpKeys — maps live my.collabkare.id routes (src/routes/PrivateRoutes.jsx,
 * paths from src/resources/routesConstants.js) to learn.collabkare.com
 * helpKeys consumed by @collabkare/help <HelpButton>.
 *
 * Keys come from the docs-site help-map — do NOT invent new ones.
 * Resolution: longest-prefix match over static routes (segment-aligned),
 * then the app-level fallback.
 */

const FALLBACK_KEY = 'myaccount.overview.index';

// Static routes, matched by longest prefix (on whole path segments).
const PREFIX_MAP = [
  // Profile (SLUGS.profile)
  ['/profile', 'myaccount.profile.update'],
  // Security — password, TOTP, sessions (SLUGS.security)
  ['/security', 'myaccount.security.manage'],
  // Subscriptions (SLUGS.subscriptions)
  ['/subscriptions', 'myaccount.subscriptions.manage'],
  // Credits (SLUGS.credits)
  ['/credits', 'myaccount.credits.buy'],
  // Purchase history / invoices (SLUGS.purchaseHistory)
  ['/purchases', 'myaccount.purchases.invoice'],
];

export function resolveHelpKey(pathname = '') {
  const path = (pathname || '').replace(/\/+$/, '') || '/';

  let best = null;
  for (const [prefix, key] of PREFIX_MAP) {
    if (path === prefix || path.startsWith(`${prefix}/`)) {
      if (!best || prefix.length > best[0].length) best = [prefix, key];
    }
  }
  if (best) return best[1];

  return FALLBACK_KEY;
}

export default resolveHelpKey;
